<template>
  <div>
    <container-headline
      :headline="'Zeitbetriebsangaben'"
      :col="6"
    ></container-headline>
    <div class="row mb-3">
      <div class="col-xl-12 block br-t-l-0">
        <div class="eingabe-panel-kopf p-3">
          <div class="row">
            <div class="col-xl-6 form-group">
              <v-select
                v-model="firma.zeitbetriebsangaben.sanitaereEinrichtung"
                :options="sanitaereeinrichtungen"
                :disabled="!editable"
                multiple
                placeholder=""
                label="bezeichnung"
              >
                <span slot="no-options">{{ $t("global.taptosearch") }}</span>
              </v-select>
              <label>Sanitäre Einrichtung</label>
            </div>
            <div class="col-xl-6">
              <div class="form-group">
                <input
                  v-model.trim="firma.zeitbetriebsangaben.erreichbarkeit"
                  class="form-control"
                  placeholder=" "
                  :readonly="!editable"
                />
                <label>Erreichbarkeit</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6">
              <div class="form-group">
                <input
                  v-model.trim="firma.zeitbetriebsangaben.weiterePersonen"
                  class="form-control"
                  placeholder=" "
                  :readonly="!editable"
                />
                <label>Weitere Personen</label>
              </div>
            </div>
            <div class="col-xl-6">
              <div class="form-group">
                <textarea
                  :disabled="!editable"
                  v-model="firma.zeitbetriebsangaben.weiterePersonenBemerkung"
                  class="form-control"
                  rows="2"
                  style="resize: vertical"
                ></textarea>
                <label>Weitere Personen Bemerkung</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-check col-xl-6" style="padding-left: 36px">
              <input
                type="checkbox"
                v-model="firma.zeitbetriebsangaben.hatElektrizitaet"
                class="form-check-input"
                :disabled="!editable"
              />
              <label>Es hat Elektrizität</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContainerHeadline from "@/components/ContainerHeadline.vue";
import store from "@/store";

export default {
  name: "Zeitbetriebsangaben",
  components: { ContainerHeadline },
  mixins: [],
  store,
  props: {
    editable: {
      type: Boolean,
      default: false,
    },
    firma: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    sanitaereeinrichtungen() {
      if (this.$store)
        return this.$store.state.agrivivaFirma.sanitaereinrichtungen;
      return [];
    },
  },
  watch: {},
  methods: {},
};
</script>
